import React from "react";
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Image,
  Divider,
  HStack,
  Link as ChakraLink,
  useColorModeValue,
  IconButton,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { FaLinkedin, FaXTwitter, FaYoutube } from "react-icons/fa6";

export default function Footer() {
  const bg = useColorModeValue("#e2e1dc", "rgba(16,16,16,0.9)");
  const border = useColorModeValue("rgba(0,0,0,0.08)", "rgba(255,255,255,0.10)");
  const text = useColorModeValue("#315369", "white");
  const sub = useColorModeValue("gray.700", "gray.300");
  const accent = "#DC242C";

  const linkProps = {
    as: RouterLink,
    fontWeight: "800",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    fontSize: "sm",
    color: sub,
    _hover: { color: accent, textDecoration: "underline" },
  };

  return (
    <Box bg={bg} borderTop="1px solid" borderColor={border}>
      <Container maxW="1200px" py={{ base: 10, md: 12 }}>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 10, md: 8 }}>
          {/* Brand / Acknowledgement */}
          <Stack spacing={4}>
            <HStack spacing={3} align="center">
              <Image
                src="header-logo.png"
                alt="SITE-CAV"
                w="44px"
                h="44px"
                objectFit="contain"
              />
              <Box lineHeight={1.05}>
                <Text fontWeight="900" fontSize="lg" color={text}>
                  SITE-CAV
                </Text>
                <Text fontSize="sm" color={sub}>
                  Connected & Autonomous Vehicles
                </Text>
              </Box>
            </HStack>

            <HStack spacing={3} align="flex-start">
              <Image
                src="ORF.png"
                alt="Ontario Research Fund"
                w="52px"
                h="52px"
                objectFit="contain"
                flexShrink={0}
              />
              <Text fontSize="sm" color={sub} textAlign="left">
                We acknowledge the support of the Ontario Ministry of Colleges and Universities through the
                Ontario Research Fund–Research Excellence (ORF-RE) Program.
              </Text>
            </HStack>
          </Stack>

          {/* Quick Links */}
          <Stack spacing={4}>
            <Text fontWeight="900" color={text} letterSpacing="0.08em" textTransform="uppercase">
              Quick Links
            </Text>

            <SimpleGrid columns={2} spacing={3}>
              <ChakraLink {...linkProps} to="/">
                Home
              </ChakraLink>
              <ChakraLink {...linkProps} to="/about-us">
                Team
              </ChakraLink>
              <ChakraLink {...linkProps} to="/program">
                Program
              </ChakraLink>
              <ChakraLink {...linkProps} to="/seminars">
                Seminars
              </ChakraLink>
              <ChakraLink {...linkProps} to="/publications">
                Publications
              </ChakraLink>
              <ChakraLink {...linkProps} to="/news">
                News
              </ChakraLink>
              <ChakraLink {...linkProps} to="/contact-us">
                Contact
              </ChakraLink>
            </SimpleGrid>
          </Stack>

          {/* Contact / Social */}
          <Stack spacing={4}>
            <Text fontWeight="900" color={text} letterSpacing="0.08em" textTransform="uppercase">
              Connect
            </Text>

            <Stack spacing={2}>
              <Text fontSize="sm" color={sub}>
                University of Ottawa • SITE-CAV
              </Text>
              {/* If you have an email, add it here */}
              {/* <Text fontSize="sm" color={sub}>Email: sitecav@uottawa.ca</Text> */}
              <Text fontSize="sm" color={sub}>
                Collaborations: academia • industry • public sector
              </Text>
            </Stack>

            
          </Stack>
        </SimpleGrid>

        <Divider my={{ base: 8, md: 10 }} borderColor={border} />

        {/* Bottom strip */}
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} alignItems="center">
          <Text fontSize="sm" color={sub}>
            © {new Date().getFullYear()} SITE-CAV. All rights reserved.
          </Text>

          <Text
            fontSize="sm"
            color={sub}
            textAlign={{ base: "left", md: "right" }}
            fontWeight="700"
            letterSpacing="0.02em"
          >
            Secure, Intelligent & Trustworthy Ecosystems for <br/> Connected and Autonomous Vehicles
          </Text>
        </SimpleGrid>
      </Container>
    </Box>
  );
}
